// extracted by mini-css-extract-plugin
export default {"tag":"BlueTag_tag__eh5N-"};